import { Button, LoadSpinner } from '@calizahq/react-components-v2'
import React, { useMemo } from 'react'

import { BottomSheet, NoResults, Table } from '@/components'
import { MarketSegmentFilter } from '@/components/ListFilter'
import { useMobile, useToggle } from '@/hooks'
import useScheduledCommunicationTemplates from '@/hooks/useScheduledCommunicationTemplates/useScheduledCommunicationTemplates'

import { CreateScheduledCommunicationTemplateForm } from '../ScheduledCommunicationTemplateForms/CreateScheduledCommunicationTemplateForm'
import MobileScheduledCommunicationTemplateCard from './MobileScheduledCommunicationTemplateCard'
import { ScheduledCommunicationTemplateListColumns } from './ScheduledCommunicationTemplates.data'

export function ScheduledCommunicationTemplates() {
  const { isShown: modalShown, toggle: modalToggle } = useToggle()
  const { data: scheduledCommunicationTemplatesData, refetch, isLoading } = useScheduledCommunicationTemplates()

  const { isMobile } = useMobile()

  const data = useMemo(() => {
    return scheduledCommunicationTemplatesData &&
      scheduledCommunicationTemplatesData?.scheduledCommunicationTemplates.length > 0
      ? scheduledCommunicationTemplatesData?.scheduledCommunicationTemplates
      : []
  }, [scheduledCommunicationTemplatesData])

  const columns = useMemo(() => {
    return ScheduledCommunicationTemplateListColumns(refetch)
  }, [refetch])

  return (
    <div className="flex w-full flex-col p-4 md:p-8">
      <div className="mb-2 flex w-full items-center justify-between md:mb-8 md:flex-row">
        <h2 className="text-header-lg leading-120">Scheduled Communication Templates</h2>

        <div className="hidden md:flex">
          <Button className="bg-action-primary" onClick={modalToggle} size="small">
            New
          </Button>
        </div>
      </div>
      <div className="mb-4 flex w-full flex-row items-center  justify-end">
        <MarketSegmentFilter />
      </div>

      {isLoading ? (
        <div className="flex h-20 w-full items-center justify-center">
          <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
        </div>
      ) : (
        <>
          {isMobile ? (
            data.length > 0 ? (
              data.map((scheduledCommunicationTemplate) => (
                <MobileScheduledCommunicationTemplateCard
                  key={scheduledCommunicationTemplate.id}
                  scheduledCommunicationTemplate={scheduledCommunicationTemplate}
                />
              ))
            ) : (
              <NoResults />
            )
          ) : (
            <Table className={''} columns={columns as any} data={data} />
          )}
        </>
      )}
      <BottomSheet isVisible={modalShown} mobileFullHeight={true} onClose={modalToggle}>
        <CreateScheduledCommunicationTemplateForm refetchOnSuccess={refetch} toggle={modalToggle} />
      </BottomSheet>
    </div>
  )
}
